import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: radial-gradient(circle at top right, #ffffff 0%, #f4f7f6 100%);
  font-family: "Inter", sans-serif;
`;

export const ContentCard = styled.div`
  width: 100%;
  max-width: 800px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(177, 125, 42, 0.1);
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.05);
  animation: ${fadeIn} 0.6s ease-out;
  text-align: center;
`;

export const Title = styled.h2`
  font-size: 28px;
  background: linear-gradient(135deg, #d4af37 0%, #b17d2a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 800;
  margin-bottom: 10px;
  text-transform: uppercase;
`;

export const Description = styled.p`
  color: #666;
  margin-bottom: 30px;
  line-height: 1.6;
`;

export const IntegrationBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  border-radius: 20px;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  img {
    width: 180px;
    margin-bottom: 20px;
  }
`;

export const ConnectButton = styled.a`
  text-decoration: none;
  background: linear-gradient(135deg, #d4af37 0%, #b17d2a 100%);
  color: white;
  padding: 15px 40px;
  border-radius: 50px;
  font-weight: 700;
  font-size: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(177, 125, 42, 0.3);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(177, 125, 42, 0.4);
  }
`;

export const StatusTag = styled.div`
  margin-top: 20px;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  background: ${(props) => (props.connected ? "#e6fffa" : "#fff5f5")};
  color: ${(props) => (props.connected ? "#38b2ac" : "#f56565")};
  border: 1px solid ${(props) => (props.connected ? "#38b2ac" : "#f56565")};
`;
